

import { motion } from "framer-motion";
import { Container } from "@/components/ui/Container";
import { SectionHeading } from "@/components/ui/SectionHeading";
import { useLanguage } from "@/components/LanguageContext";

// Pre-defined list of the client logos copied to public/images/clients
const clients = [
  { name: "Ministère du Transport", src: "ministere-transport.jpg" },
  { name: "Banque Mondiale", src: "world-bank.png" },
  { name: "PNUD", src: "pnud.png" },
  { name: "Autoroute du Maroc", src: "autoroute-du-maroc.png" },
  { name: "Ville de Marrakech", src: "ville-marrakech.png" },
  { name: "Agadir Mobilité", src: "agadir-mobilite.png" },
  { name: "Casa Transport", src: "casa-transport.png" },
  { name: "UM6P", src: "um6p.png" },
  { name: "EHTP", src: "ehtp.png" },
  { name: "JESA", src: "jesa.png" },
  { name: "Artelia", src: "artelia.png" },
  { name: "CID", src: "cid.jpg" },
  { name: "NOVEC", src: "novec.jpg" },
  { name: "GEF", src: "gef.png" },
  { name: "MVD", src: "mvd.png" },
  { name: "RRM", src: "rrm.jpg" },
  { name: "Glydways", src: "Glydways.jpg" },
  { name: "Bus City", src: "bus-city.png" },
];

export function PartnersSection() {
  const { t } = useLanguage();

  // Duplicate the array to create a seamless infinite scroll loop
  const carouselItems = [...clients, ...clients];

  return (
    <section className="py-24 lg:py-28 bg-warm-white border-t border-mineral-dark overflow-hidden">
      <Container>
        <SectionHeading
          overline={t("Confiance & Références", "Network & Trust")}
          title={t("Ils nous font confiance", "Trusted by Leaders")}
          subtitle={t(
            "Nous accompagnons les acteurs publics, les ministères, les organisations internationales et les bureaux d'études de premier plan.",
            "We collaborate with public agencies, international development banks, and major engineering groups to deliver impact at scale."
          )}
        />
      </Container>

      {/* Infinite Carousel Container */}
      <div className="relative mt-16 w-full flex overflow-hidden bg-white py-10 border-y border-mineral/50 shadow-inner">
        {/* Left/Right Fade Gradients */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        <motion.div
          className="flex whitespace-nowrap items-center gap-16 md:gap-24 px-8"
          animate={{ x: [0, -1035 * 2] }} // Approximate width to scroll based on children
          transition={{
            repeat: Infinity,
            ease: "linear",
            duration: 40, // Adjust speed here
          }}
          // Ensure it stretches enough to animate smoothly
          style={{ width: "fit-content" }}
        >
          {carouselItems.map((client, index) => (
            <div
              key={`${client.name}-${index}`}
              className="relative w-56 h-32 md:w-72 md:h-40 flex-shrink-0 grayscale hover:grayscale-0 opacity-80 hover:opacity-100 transition-all duration-300 drop-shadow-sm flex items-center justify-center p-2"
            >
              <img
                src={`/images/clients/${client.src}`}
                alt={`${client.name} Logo`}
                className="w-full h-full object-contain max-h-full"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
